import { useState } from "react";
export const useTeamInformationState = () => {
    const [teamData, setTeamData] = useState(null);
      const [allMatches, setAllMatches] = useState([]);
      const [teamMatches, setTeamMatches] = useState([]);
      const [filteredMatches, setFilteredMatches] = useState([]);
      const [players, setPlayers] = useState([]);
      const [filteredPlayers, setFilteredPlayers] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      const [activeTab, setActiveTab] = useState("matches");
    
      // Years list for dropdown
      const [yearsList, setYearsList] = useState([]);
      const [currentSeason, setCurrentSeason] = useState(new Date().getFullYear().toString());
    
      const [matchFilter, setMatchFilter] = useState("upcoming");
      const [playerSearch, setPlayerSearch] = useState("");
      const [sortOrder, setSortOrder] = useState("asc");
    
      // Search state for matches
      const [matchSearchTerm, setMatchSearchTerm] = useState("");
    
      // Key to force re-fetch when season changes
      const [matchesApiKey, setMatchesApiKey] = useState(0);
      const [playersApiKey, setPlayersApiKey] = useState(0);
    return {
        teamData, setTeamData, allMatches, setAllMatches, teamMatches, setTeamMatches, filteredMatches, setFilteredMatches, players, setPlayers, filteredPlayers, setFilteredPlayers, loading, setLoading, error, setError, activeTab, setActiveTab, yearsList, setYearsList, currentSeason, setCurrentSeason, matchFilter, setMatchFilter, playerSearch, setPlayerSearch, sortOrder, setSortOrder, matchSearchTerm, setMatchSearchTerm, matchesApiKey, setMatchesApiKey, playersApiKey, setPlayersApiKey 
    }
}